



























import Vue from 'vue';
import { mapGetters } from 'vuex';
import {
  PaymentType,
  PaymentTypeDisplay,
  AchAccountHolderType,
} from '@/common/types/payments.types';
import {
  NO_PROCESSOR,
  NullableProcessor,
  Processor,
  ProcessorType,
} from '@/common/types/processors.types';
import { HostedPaymentPageUpdate } from '@/common/types/hostedPaymentPages.types';

export default Vue.extend({
  props: {
    value: {
      type: Object as () => HostedPaymentPageUpdate,
      required: true,
    },
    errors: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      PaymentType,
      PaymentTypeDisplay,
      changedCreditCardProcessor: true,
    };
  },
  mounted() {
    this.$store
      .dispatch('loadMerchantProcessors', this.context)
      .then(() => {})
      .catch(() => {
        this.$toasted.error('Failed to load processors!');
      });
    // used changedCreditCardProcessor below to distinguish between value.creditCardProcessorId being null
    // because user selected NONE vs user first loading the page and it being null by default
    this.changedCreditCardProcessor = false;
  },
  computed: {
    ...mapGetters(['processors', 'context', 'currentUserCan']),
    supportedCreditCardProcessors(): NullableProcessor[] {
      return this.supportedProcessorsForPaymentType(PaymentType.CREDIT);
    },
    supportedAchProcessors(): NullableProcessor[] {
      return this.supportedProcessorsForPaymentType(PaymentType.ACH);
    },
    supportedKeybankProcessors(): NullableProcessor[] {
      return this.supportedProcessorsForPaymentType(PaymentType.KEYBANK);
    },
    supportedProcessors(): Processor[] {
      const processorsFilteredByType = (this.processors as Processor[]).filter(
        (p) => p.supports === PaymentType.ACH,
      );
      return processorsFilteredByType;
    },
  },
  methods: {
    supportedProcessorsForPaymentType(paymentType: PaymentType): NullableProcessor[] {
      const supported: NullableProcessor[] = (this.processors as NullableProcessor[]).filter(
        (p) => p.supports === paymentType,
      ).filter((item:NullableProcessor) => this.isNotPersonalPaya(item));
      if (supported.length === 1) {
        this.presetProcessors(supported[0]);
      }
      supported.push(NO_PROCESSOR);
      return supported;
    },
    isNotPersonalPaya(processor: any) {
      return !(processor.key === ProcessorType.PAYA
        && processor.config?.type === AchAccountHolderType.PERSONAL);
    },
    presetProcessors(supportedProcessor: any) {
      // if 1 processor exists + you aren't editing (credit card and ach processor ids are both null)
      // + NONE is not selected in the dropdown, preset dropdown with 1st processor
      if (!this.value.creditCardProcessorId && !this.value.achProcessorId && supportedProcessor
        && supportedProcessor.supports === PaymentType.CREDIT && !this.changedCreditCardProcessor) {
        this.changedCreditCardProcessor = true;
        this.value.creditCardProcessorId = supportedProcessor.id;
      } else if (!this.value.achProcessorId && !this.value.creditCardProcessorId && supportedProcessor
        && supportedProcessor.supports === PaymentType.ACH) {
        this.value.achProcessorId = supportedProcessor.id;
      }
    },
    hasProcessorBeenChosen(): boolean {
      if (
        (this.value.creditCardProcessorId !== '' || this.value.achProcessorId !== '')
        && (this.value.creditCardProcessorId !== null || this.value.achProcessorId !== null)
        && (this.value.creditCardProcessorId !== null || this.value.achProcessorId !== '')
        && (this.value.creditCardProcessorId !== '' || this.value.achProcessorId !== null)
      ) {
        return true;
      }
      return false;
    },
    validate(): boolean {
      return (
        (this.$refs.creditCardProcessorId as any).validate()
        && (this.$refs.achProcessorId as any).validate()
      );
    },
  },
});
